import styles from './Menu.module.scss';
import { AiOutlineMenu } from 'react-icons/ai';

const Menu = (props) => {

    const scrollTo = (e) => {
        e.preventDefault();
        document.querySelector(e.target.hash).scrollIntoView({
            behavior: 'smooth', block: e.target.innerHTML === "Home" ? "center" : "start" 
        });
    }

    return (
        <nav className={styles.menu}>
            <ul className={styles['menu-desktop']}>
                <li>
                    <a onClick={scrollTo} href="#banner">Home</a>
                </li>
                <li>
                    <a onClick={scrollTo} href="#about">About</a>
                </li>
                <li>
                    <a onClick={scrollTo} href="#projects">Projects</a>
                </li>
                <li>
                    <a onClick={scrollTo} href="#contact">Contact</a>
                </li>
            </ul> 
            <ul className={styles['menu-icons']}>
                <li>
                    <button onClick={() => props.menuHandler() }><AiOutlineMenu color="black"/></button>
                </li>
            </ul>  
        </nav>    
    );
}

export default Menu;
